import React from "react";
// import OptionAsahi from "./OptionAsahi";
import OptionHada from "./OptionHada";
import StemAsahi from "./StemAsahi";
import StemHada from "./StemHada";
const Tabs = ({ color }) => {
  const [openTab, setOpenTab] = React.useState(1);
  const svg =<svg class="h-6 w-6 text-orange-500 inline"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
</svg>

  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full">
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6  border-0">
            <div className="px-4 py-5 flex-auto">
              <div className="tab-content tab-space">
                  {/* 秦校　str */}
                  <StemHada />
                  {/* <OptionHada /> */}
                  {/* 秦校 End */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default function Tab() {
  return (
    <>
      <Tabs color="orange" />
    </>
  );
}
